import { verifyPasswordResetCode } from 'firebase/auth';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';
import { mapResetPasswordError } from 'shared/utils/map-reset-password-error';

import { getAuthentication } from './helpers';

export const getEmailByOobcode = async (oobCode: string) => {
  try {
    const auth = await getAuthentication();

    return await verifyPasswordResetCode(auth, oobCode);
  } catch (e: unknown) {
    const errorCode = (e as { code?: string } | null)?.code ?? '';
    const kind = mapResetPasswordError(errorCode);
    if (kind === ResetPasswordErrorTypes.Unknown) {
      getErrorReporter().captureException(e, {
        tags: { source: 'verify-password-reset-code' },
      });
    }
    throw kind;
  }
};
